import {Injectable} from '@angular/core';
import Dexie from 'dexie';
import {db} from '../../tables/db.service';
import {StorageItem} from '../../interfaces/core/storage-item';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  private static _table: Dexie.Table<StorageItem, string> = null;

  constructor() { }

  /**
   *
   */
  public async init(): Promise<void> {
    StorageService._table = db.storage;
  }

  /**
   *
   * @param key
   * @param value
   */
  public static async setItem(key: string, value: any): Promise<void> {
    await StorageService._table.put({ key, value });
  }

  /**
   *
   * @param key
   * @param _default
   */
  public static async getItem<T>(key: string, _default: any = null): Promise<T> {
    const item =  await StorageService._table.get(key);
    return item ? item.value : _default;
  }

  /**
   *
   * @param key
   */
  public static async removeItem(key: string): Promise<void> {
    await StorageService._table.delete(key);
  }

  /**
   *
   * @param key
   */
  public static async isset(key: string): Promise<boolean> {
    return !!await StorageService._table.get(key);
  }

  /**
   *
   * @param key
   * @param value
   */
  public async setItem(key: string, value: any): Promise<void> {
    await StorageService.setItem(key, value);
  }

  /**
   *
   * @param key
   * @param _default
   */
  public async getItem(key: string, _default: any = null): Promise<any> {
    return StorageService.getItem(key, _default);
  }

  /**
   *
   * @param key
   */
  public async removeItem(key: string): Promise<void> {
    await StorageService.removeItem(key);
  }

  /**
   *
   * @param key
   */
  public async isset(key: string): Promise<boolean> {
    return StorageService.isset(key);
  }

  /**
   *
   * @param exceptKeys
   */
  public async clear(exceptKeys: string[] = []): Promise<void> {
    if(exceptKeys.length > 0) {
      const items = await StorageService._table.toArray();
      for(const item of items) {
        if(!exceptKeys.some(_exceptKey => _exceptKey === item.key)) {
          await StorageService._table.delete(item.key);
        }
      }
    }
    else {
      await StorageService._table.clear();
    }
  }

}
